import { v4 } from 'uuid';
import { TRACE_ID_NAME, featureFlags } from './constants';
import { affordabilityMock } from './mocks/affordabilityMock';
import { interestRates } from './mocks/interestRatesMock';
import {
  AffordabilityRequest,
  AffordabilityResponse,
  InterestRatesRequest,
  InterestRatesResponse,
} from './types';

export async function fetchInterestRate(
  data: InterestRatesRequest,
  mocked?: boolean,
): Promise<InterestRatesResponse | number> {
  const url = getInterestRateEndpointUrl();

  if (mocked) {
    await new Promise((resolve) => setTimeout(resolve, 1500));
    return interestRates;
  }

  const init: RequestInit = {
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json', [TRACE_ID_NAME]: v4() },
    method: 'POST',
    signal: AbortSignal.timeout(10_000),
  };

  return fetch(url, init).then((response) => {
    if (response.ok) {
      return response.json();
    }

    throw new Error('Request could not be completed due to error');
  });
}

export async function fetchInterestRates(
  data: InterestRatesRequest,
  mocked?: boolean,
): Promise<InterestRatesResponse> {
  const url = getInterestRatesEndpointUrl();

  if (mocked) {
    await new Promise((resolve) => setTimeout(resolve, 1500));
    return interestRates;
  }

  const init: RequestInit = {
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json', [TRACE_ID_NAME]: v4() },
    method: 'POST',
    signal: AbortSignal.timeout(10_000),
  };

  return fetch(url, init).then((response) => {
    if (response.ok) {
      return response.json();
    }

    throw new Error('Request could not be completed due to error');
  });
}

export async function fetchAffordability(
  data: AffordabilityRequest,
  mocked?: boolean,
): Promise<AffordabilityResponse> {
  if (mocked) {
    return affordabilityMock;
  }

  const url = getAffordabilityUrl();
  const init: RequestInit = {
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json', [TRACE_ID_NAME]: v4() },
    method: 'POST',
  };

  return fetch(url, init).then((response) => {
    if (response.ok) {
      return response.json();
    }

    throw new Error('Request could not be completed due to error');
  });
}

function isDevEnvironment(host: string) {
  return host === 'dev.danskenet.net' || host.endsWith('.dev.danskenet.net');
}

function getInterestRateEndpointUrl() {
  if (isDevEnvironment(window.location?.host)) {
    return featureFlags.use3MonthInterestRate
      ? `/api/calculator/se/interest-rate`
      : `/api/calculator/se/interest-rates`;
  }

  return featureFlags.use3MonthInterestRate
    ? `https://${window.location.host}/bostad/api/calculator/se/interest-rate`
    : `https://${window.location.host}/bostad/api/calculator/se/interest-rates`;
}

function getInterestRatesEndpointUrl() {
  if (isDevEnvironment(window.location?.host)) {
    return `/api/calculator/se/interest-rates`;
  }

  return  `https://${window.location.host}/bostad/api/calculator/se/interest-rates`;
}

function getAffordabilityUrl() {
  if (isDevEnvironment(window.location?.host)) {
    return `/api/calculator/se/calculate-limit`;
  }

  return `https://${window.location.host}/bostad/api/calculator/se/calculate-limit`;
}
